
function quizPageAnimation() 
{
    var startedButtons = document.querySelectorAll( ".start_quiz" );
    startedButtons.forEach(( startedButton ) =>
    {
        startedButton.addEventListener( "click", function(e)
        {
			var next_section = this.dataset.next_section;
			var nextSection = document.querySelector( "." + next_section );
            var started_button = SearchParentsFor( startedButton, "started_button" );
            var nextparentSection = SearchParentsFor( nextSection, "quiz-section" );
            
            started_button.classList.add( "hidden" );

            nextparentSection.classList.remove( "hidden" );
            nextSection.classList.remove( "hidden" );
			
            var parentSection = SearchParentsFor( startedButton, "quiz-section" );
            parentSection.classList.add( "shrink" );
            if( document.querySelector( ".quiz_intro_slider" ) )
            {
                initslider();
            }
        });
    });
}

window.addEventListener( "DOMContentLoaded", function(e)
{
    quizPageAnimation();
});